/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import WebpageEditContext from "components/webpage-selector/context";
import { objectHasPropertyString } from "utils/empty-exists";
import { ReactComponent as EditIcon } from "assets/images/icons/common/edit.svg";
import { ReactComponent as FileRegularIcon } from "assets/images/icons/common/file-regular.svg";

const NewsItemDisplay = (props) => {
    
    const {
        setOpen,
        webpage = "",
        onChange
    } = useContext(WebpageEditContext);
    
    const hasWebpage = objectHasPropertyString(webpage, "guid");

    return (
        <Fragment>
            {hasWebpage ? (
                <div className="news-highlights-news-item-display">
                    <div className="news-highlights-news-item-display-content">
                        <div className="news-highlights-news-item-display-doc-icon">
                            <FileRegularIcon />
                        </div>
                        <div className="news-highlights-news-item-display-info-wrapper">
                            <div className="news-highlights-news-item-display-info-title">
                                {webpage?.nav_title || webpage?.title || webpage?.file_name || "Untitled"}
                            </div>
                            <div className="news-highlights-news-item-display-info-path">
                                {webpage?.path || "N/A"}
                            </div>
                        </div>
                        <div 
                            className="news-highlights-news-item-display-edit"
                            onClick={onChange}
                        >
                            <EditIcon />
                        </div>
                    </div>
                </div>
            ) : (
                <Fragment>
                    {props.AddComponent ? (
                        <props.AddComponent
                            webpage={webpage}
                            setOpen={setOpen}
                            onClick={() => setOpen(true)}
                        />
                    ) : null}
                </Fragment>
            )}
        </Fragment>
    );
};

NewsItemDisplay.displayName = "NewsItemDisplay";
export { NewsItemDisplay };

